import { render, staticRenderFns } from "./CellRendererHoursOfWork24h.vue?vue&type=template&id=2050fc42"
import script from "./CellRendererHoursOfWork24h.vue?vue&type=script&lang=js"
export * from "./CellRendererHoursOfWork24h.vue?vue&type=script&lang=js"
import style0 from "./CellRendererHoursOfWork24h.vue?vue&type=style&index=0&id=2050fc42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports